import template   from './confirmation.html'
import controller from './confirmation.controller'
import './confirmation.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/confirmation/confirmation.component.js